import React from 'react'

import { HouseNightlyTripGlobalSeasonalPriceField } from './components/HouseNightlyTripGlobalSeasonalPriceField'
import { Divider } from '../../../../../../../../../atoms/divider/Divider'
import { HouseNightlyTripGlobalFieldProps } from '../../../form-container/HouseNightlyTripGlobalFormContainer'

export const HouseNightlyTripGlobalSeasonalPricesFields = (
  props: HouseNightlyTripGlobalFieldProps,
) => {
  return (
    <>
      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekDay.lowPrice'
      />
      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekEnd.lowPrice'
      />

      <Divider />

      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekDay.mediumPrice'
      />
      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekEnd.mediumPrice'
      />

      <Divider />

      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekDay.highPrice'
      />
      <HouseNightlyTripGlobalSeasonalPriceField
        {...props}
        name='weekEnd.highPrice'
      />

      <Divider />
    </>
  )
}
